"use client"

import { ShoppingCart } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useCart } from "@/lib/context/cart-context"
import FulfillmentToggle from "./fulfillment-toggle"

export default function CartButton({ showFulfillmentToggle = true }: { showFulfillmentToggle?: boolean } = {}) {
  const { cart, openCart } = useCart()

  const itemCount = cart.items.reduce((sum, item) => sum + item.quantity, 0)
  const subtotal = cart.subtotal.toFixed(2)

  return (
    <div className="flex items-center gap-3">
      {showFulfillmentToggle && <FulfillmentToggle />}
      
      <div className="flex items-center gap-2">
        {itemCount > 0 && (
          <span className="text-sm font-medium hidden md:inline-block">
            ${subtotal}
          </span>
        )}
        
        <Button 
          variant="ghost" 
          className="relative p-2" 
          onClick={openCart} 
          aria-label="Open cart"
        >
          <ShoppingCart className="h-5 w-5" />
          {itemCount > 0 && (
            <span className="absolute top-0 right-0 bg-primary_green text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
              {itemCount}
            </span>
          )}
        </Button>
      </div>
    </div>
  )
}
